import "./css/app.scss"
import "./ts/neto.js"
import "./ts/slider"

import lazyLoad from "./ts/lazyLoad"
import loadSprite from "./ts/loadSprite"
import dropdown from "./ts/dropdowns"
import popups from "./ts/popups"
import mobMenu from "./ts/mobMenu"
import accordian from "./ts/accordian"
import clearFilters from "./ts/clearFilters"
import stickyHeader from "./ts/stickyHeader"

loadSprite.init()
lazyLoad.init()
dropdown.init()
popups.init()
mobMenu.init()
accordian.init()
clearFilters.init()
stickyHeader.init()
window.resetEvent = new Event("reset")

